import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const At = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb4bb__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g clipPath="url(#bb4bb__a)">
            <path
              fillRule="evenodd"
              d="M24 8C15.163 8 8 15.163 8 24s7.163 16 16 16c3.774 0 7.238-1.304 9.974-3.488l2.496 3.126A19.924 19.924 0 0 1 24 44C12.954 44 4 35.046 4 24S12.954 4 24 4s20 8.954 20 20a7.5 7.5 0 0 1-7.5 7.5c-2.31 0-4.207-1.306-5.451-2.862a2.933 2.933 0 0 1-.017-.02A9 9 0 1 1 33 23c0 1.016.43 2.21 1.173 3.14.747.934 1.599 1.359 2.327 1.359A3.5 3.5 0 0 0 40 24c0-8.837-7.163-16-16-16Zm5 15a5 5 0 1 0-10 0 5 5 0 0 0 10 0Z"
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
